import { r, s } from '@/theme/tokens';
import {
  interactiveHoverSurfaceBackground,
  interactiveHoverSurfaceSx,
} from '@/ui/primitives/interactionStyles';
import type { SxProps, Theme } from '@/ui/primitives';

export const tableControlSurfaceBackground = 'var(--surface-card)';
export const tablePopoverSurfaceBackground = 'var(--surface-page)';
export const tableOverlaySurfaceBackground = 'var(--surface-overlay)';
export const tableControlHoverBackground = interactiveHoverSurfaceBackground;

export const tablePanelSurfaceSx = {
  width: '100%',
  minWidth: 0,
  py: s('none'),
  px: s('md'),
} satisfies SxProps<Theme>;

export const tablePopoverSurfaceSx = {
  backgroundColor: tablePopoverSurfaceBackground,
  backgroundImage: 'none',
  '--Paper-overlay': 'none',
} satisfies SxProps<Theme>;

export const tablePopoverPaperSx = {
  ...tablePopoverSurfaceSx,
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: `${r('md')} !important`,
  boxShadow: 'none',
  overflow: 'hidden !important',
} satisfies SxProps<Theme>;

export const tableOverlaySurfaceSx = {
  backgroundColor: tableOverlaySurfaceBackground,
  backgroundImage: 'none',
  boxShadow: 'none',
  '--Paper-overlay': 'none',
} satisfies SxProps<Theme>;

export const tableQuickSortBadgeSurfaceSx = {
  backgroundColor: tableControlSurfaceBackground,
} satisfies SxProps<Theme>;

export const tableControlSurfaceSx = {
  backgroundColor: tableControlSurfaceBackground,
} satisfies SxProps<Theme>;

export const tableControlHoverSx = interactiveHoverSurfaceSx satisfies SxProps<Theme>;

export const tableActionsTriggerWrapperSx = {
  display: 'inline-flex',
} satisfies SxProps<Theme>;

export const buildTableActionsCellFrameSx = (verticalAlign: 'top' | 'center'): SxProps<Theme> => ({
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: verticalAlign === 'center' ? 'center' : 'flex-start',
  pt: verticalAlign === 'center' ? s('none') : s('sm'),
});

export const buildTableActionsTriggerSx = (actionsDisabled: boolean): SxProps<Theme> => ({
  width: '28px',
  height: '28px',
  minWidth: '28px',
  minHeight: '28px',
  p: s('none'),
  borderRadius: r('pill'),
  color: actionsDisabled ? 'text.disabled' : undefined,
  '&:hover, &.Mui-focusVisible': actionsDisabled
    ? undefined
    : {
        backgroundColor: tableControlHoverBackground,
      },
});

export const tableActionsMenuPaperSx = {
  mt: s('sm'),
  border: (theme) => `1px solid ${theme.app.colors.border}`,
  borderRadius: `${r('card')} !important`,
} satisfies SxProps<Theme>;

export const tableActionsMenuListSx = {
  px: s('none'),
  py: s('none'),
} satisfies SxProps<Theme>;

export const tableActionsMenuItemSx = {
  minHeight: '40px',
  gap: s('md'),
  px: s('lg'),
  py: s('md'),
} satisfies SxProps<Theme>;
